// tslint:disable
/* MACLE TypeScript 31/07/2026 23:43:12 */
import { DataEmiteBoletoZoop } from '../vo/maclepagamento.vo';
import { DataResultEmitePixZoopAPP, DataResultEmiteBoletoZoopAPP, PKLiquidacaoParcelaAPP } from '../vo/sitevo.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ZoopModelService extends BaseService {
  private _url = 'zoopService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public emitePIXLiquidacaoParcela(pix: DataEmiteBoletoZoop): Promise<DataResultEmitePixZoopAPP> {
    let params = {
      "pix": pix
    };
    return this.ajax.post(this._url + 'emitePIXLiquidacaoParcela', params)
      .then((r: IModelServiceResponse<DataResultEmitePixZoopAPP>) => Parser.jsonToClass(r.value, DataResultEmitePixZoopAPP))
      .catch((error: any) => this.handleError(error));
  }

  public emiteBoletoLiquidacaoParcela(boleto: DataEmiteBoletoZoop): Promise<DataResultEmiteBoletoZoopAPP> {
    let params = {
      "boleto": boleto
    };
    return this.ajax.post(this._url + 'emiteBoletoLiquidacaoParcela', params)
      .then((r: IModelServiceResponse<DataResultEmiteBoletoZoopAPP>) => Parser.jsonToClass(r.value, DataResultEmiteBoletoZoopAPP))
      .catch((error: any) => this.handleError(error));
  }

  public inativaBoleto(pk: PKLiquidacaoParcelaAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'inativaBoleto', params)
      .then((r: IModelServiceResponse<string>) => r.value === "OK")
      .catch((error: any) => this.handleError(error));
  }

}


